import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-reset-password',
  templateUrl: './icon-reset-password.component.html',
  styles: []
})
export class IconResetPasswordComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
